import React from 'react'
import { initializeApollo } from 'gql/client'
import {MINISITO_NAME, PAGINA } from 'utils/queries'
import PupuCheckTemplate from '@components/templates/PupuCheckTemplate/PupuCheckTemplate'
import { NextWrapper } from 'data-fetching-wrapper'


const PupuCheckPage = ({ pagina, minisitoName }) => <PupuCheckTemplate pagina={pagina} brand={minisitoName} />


export const getStaticProps = NextWrapper.getStaticProps(async () => {
  const client = initializeApollo()



  //Recupero brand Aptashop 
  const {
    data: { minisitoName },
  } = await client.query({
    query: MINISITO_NAME,
    variables: { name: "AptaShop"},
  })

  if (!minisitoName) {
    return {
      notFound: true,
    }
  }
  

  const {
    data: { pagina },
  } = await client.query({
    query: PAGINA,
    variables: { chiave: 'aptamil-pupu-check' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }
  return {
    props: { pagina: pagina || null, minisitoName },
    revalidate: 60 * 2,
  }
}, '/aptamil-pupu-check')

export default PupuCheckPage
